import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import ScheduleService from '../../services/scheduleServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('schedule/list', async ({ start, end, user_id }, thunkAPI) => {
  try {
    const response = await ScheduleService.getList(start, end, user_id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListSemester = createAsyncThunk('schedule/getListSemester', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListSemester(jenjang, cabang);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListWeekly = createAsyncThunk('schedule/getListWeekly', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListWeekly(jenjang, cabang);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListTahunan = createAsyncThunk('schedule/getListTahunan', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListTahunan(jenjang, cabang);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListBulanan = createAsyncThunk('schedule/getListBulanan', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListBulanan(jenjang, cabang);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListMingguan = createAsyncThunk('schedule/getListMingguan', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListMingguan(jenjang, cabang);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListHarian = createAsyncThunk('schedule/getListHarian', async ({ jenjang, cabang }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListHarian(jenjang, cabang);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListArchive = createAsyncThunk('schedule/getListArchive', async ({ year, month, user_id }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListArchive(year, month, user_id);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListDaily = createAsyncThunk('schedule/getListDaily', async ({ date, user_id }, thunkAPI) => {
  try {
    const response = await ScheduleService.getListDaily(date, user_id);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('schedule/create', async (data, thunkAPI) => {
  try {
    const response = await ScheduleService.create(data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('schedule/read', async (id, thunkAPI) => {
  try {
    const response = await ScheduleService.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('schedule/update', async ({ id, data }, thunkAPI) => {
  try {
    const response = await ScheduleService.update(id, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('schedule/delete', async (id, thunkAPI) => {
  try {
    const response = await ScheduleService.del(id);
    return response.data;
  } catch (error) {
    if (error.response?.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response?.data || error);
  }
});

export const changeStatus = createAsyncThunk('schedule/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await ScheduleService.changeStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changeStudentAttend = createAsyncThunk('schedule/changeStudentAttend', async ({ id, data }, thunkAPI) => {
  try {
    const response = await ScheduleService.changeStudentAttend(id, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const uploadPhoto = createAsyncThunk('schedule/uploadPhoto', async ({ id, data }, thunkAPI) => {
  try {
    const response = await ScheduleService.uploadPhoto(id, data);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deletePhoto = createAsyncThunk('schedule/deletePhoto', async ({ id, fileID }, thunkAPI) => {
  try {
    const response = await ScheduleService.deletePhoto(id, fileID);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const exportSemesterSchedule = createAsyncThunk('schedule/exportSemesterSchedule', async (_, thunkAPI) => {
  try {
    const response = await ScheduleService.exportSemesterSchedule();
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const exportWeeklySchedule = createAsyncThunk('schedule/exportWeeklySchedule', async (_, thunkAPI) => {
  try {
    const response = await ScheduleService.exportWeeklySchedule();
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const exportTahunanSchedule = createAsyncThunk('schedule/exportTahunanSchedule', async (_, thunkAPI) => {
  try {
    const response = await ScheduleService.exportTahunanSchedule();
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const exportBulananSchedule = createAsyncThunk('schedule/exportBulananSchedule', async (_, thunkAPI) => {
  try {
    const response = await ScheduleService.exportBulananSchedule();
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const exportHarianSchedule = createAsyncThunk('schedule/exportHarianSchedule', async (_, thunkAPI) => {
  try {
    const response = await ScheduleService.exportHarianSchedule();
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const exportAllSchedules = createAsyncThunk('schedule/exportAllSchedules', async (_, thunkAPI) => {
  try {
    const response = await ScheduleService.exportAllSchedules();
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], daily: [], data: [], error: [], semester: [], weekly: [], tahunan: [], bulanan: [], mingguan: [], harian: [] };

const scheduleSlice = createSlice({
  name: 'schedule',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListDaily.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListDaily.fulfilled, (state, action) => {
        state.isLoading = false;
        state.daily = action.payload;
      }),
      builder.addCase(getListDaily.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors ?? [];
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStudentAttend.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStudentAttend.fulfilled, (state, action) => {
        state.isLoading = false;
        // Preserve original schedule data and only update attendance data
        if (state.data && action.payload) {
          state.data = {
            ...state.data,
            attend: action.payload.attend || state.data.attend,
            photos: action.payload.photos || state.data.photos
          };
        } else {
          state.data = action.payload;
        }
      }),
      builder.addCase(changeStudentAttend.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(uploadPhoto.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(uploadPhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        // Preserve original schedule data and only update photos data
        if (state.data && action.payload) {
          state.data = {
            ...state.data,
            photos: action.payload.photos || state.data.photos,
            attend: action.payload.attend || state.data.attend
          };
        } else {
          state.data = action.payload;
        }
      }),
      builder.addCase(uploadPhoto.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deletePhoto.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deletePhoto.fulfilled, (state, action) => {
        state.isLoading = false;
        // Preserve original schedule data and only update photos data
        if (state.data && action.payload) {
          state.data = {
            ...state.data,
            photos: action.payload.photos || state.data.photos,
            attend: action.payload.attend || state.data.attend
          };
        } else {
          state.data = action.payload;
        }
      }),
      builder.addCase(deletePhoto.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListSemester.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListSemester.fulfilled, (state, action) => {
        state.isLoading = false;
        state.semester = action.payload;
      }),
      builder.addCase(getListSemester.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListWeekly.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListWeekly.fulfilled, (state, action) => {
        state.isLoading = false;
        state.weekly = action.payload;
      }),
      builder.addCase(getListWeekly.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListTahunan.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListTahunan.fulfilled, (state, action) => {
        state.isLoading = false;
        state.tahunan = action.payload;
      }),
      builder.addCase(getListTahunan.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListBulanan.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListBulanan.fulfilled, (state, action) => {
        state.isLoading = false;
        state.bulanan = action.payload;
      }),
      builder.addCase(getListBulanan.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListMingguan.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListMingguan.fulfilled, (state, action) => {
        state.isLoading = false;
        state.mingguan = action.payload;
      }),
      builder.addCase(getListMingguan.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(getListHarian.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getListHarian.fulfilled, (state, action) => {
        state.isLoading = false;
        state.harian = action.payload;
      }),
      builder.addCase(getListHarian.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(exportSemesterSchedule.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(exportSemesterSchedule.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(exportSemesterSchedule.rejected, (state) => {
        state.isLoading = false;
      });

    builder.addCase(exportWeeklySchedule.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(exportWeeklySchedule.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(exportWeeklySchedule.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = scheduleSlice;
export default reducer;
